import { debug } from "@/utils/debug/logger";

export const APPLE_CLIENT_ID = import.meta.env.VITE_APPLE_CLIENT_ID || "";
export const APPLE_REDIRECT_URI = import.meta.env.VITE_APPLE_REDIRECT_URI || "";

export const initializeAppleSignIn = () => {
  // const script = document.createElement("script");
  // script.src =
  //   "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";
  // script.async = true;
  // script.defer = true;

  // debug.log("appleAuth", "Initializing Apple Sign In");
  // debug.log("appleAuth", "Apple Client ID:", APPLE_CLIENT_ID);
  // debug.log("appleAuth", "Apple Redirect URI:", APPLE_REDIRECT_URI);

  // script.onload = () => {
  //   window.AppleID.auth.init({
  //     clientId: APPLE_CLIENT_ID,
  //     scope: "email",
  //     redirectURI: APPLE_REDIRECT_URI,
  //     usePopup: true, // This enables popup flow instead of redirect
  //   });
  // };

  // document.head.appendChild(script);
  debug.log("appleAuth", "Apple Sign In IS NOT! initialized");
};
